import React from 'react';
import { UserContext } from './UserContext';
import { UserProfile } from '@teetsh/app/src/types/user';

interface Props {
  user: Partial<UserProfile>;
  children: any;
}

export default function FakeUserProvider({ user, ...rest }: Props) {
  return <UserContext.Provider value={user as UserProfile} {...rest} />;
}
